<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">Profit/(Loss) per Program - Master    
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Program Name</label></b-input-group-prepend>
                <b-form-input v-model="tblData.prognama" ></b-form-input>
                <b-input-group-prepend><span class="pt-2 mr-2">Group</span></b-input-group-prepend>
                <b-form-select v-model="tblData.groupprog" :plain="true" :options="filtergroups"></b-form-select>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>News Category</label></b-input-group-prepend>
                <b-form-select  v-model="tblData.newscateg" :plain="true" :options="newscategs" ></b-form-select>
                <b-input-group-prepend><span class="pt-2 mr-2">Dep</span></b-input-group-prepend>
                <b-form-select class="ml-1" v-model="tblData.newsdep" :plain="true" :options="newsdeps" ></b-form-select>
            </b-input-group>
        </b-col>
        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><label>Production</label></b-input-group-prepend>
                <b-form-select  v-model="tblData.liveprod" :plain="true" :options="lives" class="mr-2"></b-form-select>
                <b-input-group-prepend><span class="pt-2 mr-2">Studio</span></b-input-group-prepend>
                <b-form-select  v-model="tblData.stdcostkey" :plain="true" :options="studiolives" ></b-form-select>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Blocking</label></b-input-group-prepend>
                <b-form-select v-model="tblData.blocking" :plain="true" :options="blockings"></b-form-select>
                <b-input-group-prepend><span  class="pt-2 ml-2 mr-2">&nbsp;&nbsp;&nbsp;&nbsp;Rate Spot</span></b-input-group-prepend>
                <b-form-select  v-model="tblData.spotrate" :plain="true" :options="spotrates" ></b-form-select>
                <b-input-group-append>              
                  <div style="width:200px; text-align:rught;">
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm">Clear Filter</b-button>
                  </div>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >

      </b-table>
      <b-row >
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
  </div>
</template>

<style lang="scss">
    .ColsDefine {
      .input-group {
          .input-group-prepend {
              label {
                  width: 135px !important;
              }
          }
      }
    }

</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import crud from "../../apis/crud";
import programtv from "../../apis/programtvpnl";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {Loading},
  mixins: [validationMixin],
  validations: {
        frmUpload: {
            sheetName: { required },
            startRow: { required },
            CustCode: { required },
            CustName: { required },
            uraian1: { required },
            invoiceno: { required },
            invdate: { required },
            artype: { required },
            matauang: { required },
            ttlgross: { required },
            ttlnetto: { required },
            ttlvat: { required },
            ttlamtdue: { required },
        },
    model: {
        nama: { required },
        kode: { required },
        groupprog: { required },
    },

  }, 
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      isLoading:false,
      showUploadFrm: false,
      showForm: false,
      fileXlsx: null,
      frmUpload:{sheetName:'Sheet1', startRow:8, invoiceno:'A', invdate:'B', CustCode:'C',CustName:'D', uraian1:'E', uraian2:'F', 
            matauang:'G',ttlgross:'H',ttldiskon:'I',ttlnetto:'J',ttlvat:'K',ttlamtdue:'L'},
      kolomXls:['','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
      'AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ'],
      tblFields:[
          {
            key: "kode",
            label: "Program Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "nama",
            label: "Program Name",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "groupname",
            label: "Program Group",
            sortable: true
          },
          {
            key: "news",
            label: "News Category/Dep",
            sortable: true
          },
          {
            key: "live",
            label: "Live/Taping",
            sortable: true
          },
          {
            key: "blocking",
            label: "Blocking",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "spotrate",
            label: "Rate Spot",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "quantity",
            label: "Qty",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "durasi",
            label: "DUR",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "hari",
            label: "Hari",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "jam",
            label: "Jam",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
        ],

      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'groupprog,prognama',
        sortDesc: false
      },
      model:{},
      blockings:[{ value:'', text:'--ALL--'},{ value:'1', text:'BLOCKING'},{ value:'0', text:'NON BLOCKING'}],
      lives:[{ value:'', text:'--ALL--'},{ value:'1', text:'LIVE'},{ value:'0', text:'TAPING'}],
      newscategs:['--ALL--','SOFTNEWS','HARDNEWS'],
      newsdeps:['--ALL--','MAGAZINE','NEWS GATHERING'], 
      filtergroups:[{value:'', text:'--ALL--'}],
    };
  },
  computed: {
    // dimension(){
    //   return this.$store.state.dimension;
    // },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
  },
  // watch:{
  //   dimCol: function(newval) {
  //       this.tblData.DimVal="";
  //       this.tblData.DimValInfo="";
  //       this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
  //   },
  // },
  created: async function(){
        const [a,b,c] = await Promise.all([
          crud.list({
            tablename:'programtv-group',
            sortBy: 'seqno',
            sortDesc: false
          }),
          crud.list({
            tablename:'vwstudiorate',
            sortBy: 'studioname',
            sortDesc: false
          }),
          crud.list({
            tablename:'programrate',
            sortBy: 'seqno',
            sortDesc: false
          })                    
          ]);
        this.groups = a.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[]);
        this.filtergroups=this.filtergroups.concat(this.groups);
        this.studiolives = b.reduce((newArr,item) =>{
            if (item.liveprod==1){
              newArr.push({ value: item.studiocode, text: item.studioname});
            }
            return newArr;
        },[{value:'',text:'--ALL--'}]);
        this.spotrates = c.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[{value:'',text:'--ALL--'}]);

    
      const tglaktif = moment(new Date(), 'YYYY-MM-DD');
      this.tblData.tgl1 =  tglaktif.startOf('month').format('YYYY-MM-DD');
      this.tblData.tgl2 =  tglaktif.endOf('month').format('YYYY-MM-DD');

  },  
  methods: {
    data: async function(ctx) {
      // const filter = this.$store.state.filter;
      //   let filtered=false;
      //   for (var key in filter.polist) {
      //       this.tblData[key] = filter.polist[key];
      //       filtered=true;
      //   }
      //   if (filtered === true) {
      //     this.showFilter=filtered;
      //     delete filter.polist;
      //     this.$store.commit("filter", filter);
      //   }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.isLoading=true;
      const list = await programtv.list(this.tblData);      
      this.isLoading=false;

      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        for (var key in this.tblData) {
            this.tblData[key] = '';
        }
        this.tblData.page= 1;
        this.tblData.limit= 15;
        this.tblData.total= 0;
        // this.refresh();
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    upload: async function(evt) {
        evt.preventDefault()
      if (this.invalidFrmUpload) {
            console.log('validation : ', this.$v.frmUpload);
            console.log('frmUpload obj : ',this.frmUpload);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (this.fileXlsx) {
            this.showUploadFrm = false;
            this.isLoading=true;
            try {
                const response = await programtv.upload(this.fileXlsx,this.frmUpload);
                this.isLoading=false;   
                console.log(response); 
            } catch (error) {
                this.isLoading=false;
                this.showUploadFrm = true;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }
                }
            }
        } else {
          toastr.warn('Please select one File XLSX that want to Upload ');
        }
    },
    add: function(data) {
        for (var key in this.model) {
            this.model[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.model) {
            this.model[key] = '';
        }
        for (var key in this.model) {
            this.model[key] = this.model[key];
        }
      this.model.idlama = data.kode;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidModel) {
              console.log('validation : ', this.$v.model);
              console.log('model : ',this.model);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.model.idlama) {
                await crud.update(
                     {tablename:'programtv', 
                     key:this.model.idlama, 
                     data:{nama:this.model.nama, kode:this.model.kode,groupprog:this.model.groupprog, spotrate:this.model.spotrate, progtype:this.model.progtype,
                     newscateg:this.model.newscateg,newsdep:this.model.newsdep, studiolive:this.model.studiolive, studiotape:this.model.studiotape}
                      });
              } else {
                await crud.insert(
                  { tablename:'programtv',                      
                     data:{nama:this.model.nama, kode:this.model.kode,groupprog:this.model.groupprog, spotrate:this.model.spotrate, progtype:this.model.progtype,
                     newscateg:this.model.newscateg,newsdep:this.model.newsdep, studiolive:this.model.studiolive, studiotape:this.model.studiotape}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'programtv', key:this.model.kode});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await programtv.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push('home');
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.tendering')) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
      //   // router.push({name:'payable.apinv'});
      //     router.push("home");
      // }
    }

  }
};
</script>
